import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ProgramDecisionsComponent } from './program-decisions.component';
import { DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTextBoxModule, DxPopoverModule, DxDateBoxModule, DxAutocompleteModule } from 'devextreme-angular';
import { I18nModule } from "app/shared/i18n/i18n.module";
import { MaterialModule } from 'app/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalModule } from 'ngx-bootstrap';
import { CurrencyFormatterPipeModule } from 'app/shared/currency-formatter-pipe/currencyFormatterPipe.module';

@NgModule({
  imports: [
    CommonModule,
    DxDataGridModule,
    I18nModule,
    MaterialModule,
    FormsModule,
    NgxSpinnerModule,
    ModalModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    CurrencyFormatterPipeModule,
    DxTextBoxModule,
    DxPopoverModule,
    DxDateBoxModule,
    DxAutocompleteModule
  ],
  declarations: [
    ProgramDecisionsComponent
  ],
  exports: [
    ProgramDecisionsComponent
  ]
})
export class ProgramDecisionsModule { }
